import React from 'react';
import { useForm } from "react-hook-form";
import { HorizontalBar } from 'react-chartjs-2';

import Grid from "@material-ui/core/Grid";
import Select from '@material-ui/core/Select';

import html2canvas from 'html2canvas';
import moment from 'moment'

import {
  Option,
} from "../../atom/Apollo_styles";
import {
  options_download_kind,
  options_demographic_display_period_kind,
  options_demographic_graph_campaign,
  options_demographic_graph_adgroup,
  options_setpoint_columns,
} from "../../atom/Apollo_Options";
import {
  ChartData,
  DemographicChartColumns1,
  DemographicChartColumns2,
  DEMOGRAPHIC_COLUMNS,
  SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS,
  DOWNLOAD_KIND,
  DEMOGRAPHIC_DISPLAY_PERIOD,
  GENDER_KIND,
} from "../../common/Apollo_CommonConst_Beta";
import { valueToLabel } from "../../common/Apollo_CommonUtil_Beta";
import {
    ApolloBasicRadio,
} from "../../molecule/Apollo_BaseItem";
import { ApolloIconButtonDownloadImage } from "../../molecule/Apollo_IconButtonBase_Beta";
import {
  formatChartCsvData,
  LintChartColumnsPtn,
  generate_setpoint_options_list,
  tooltip_options_format,
} from "./LineChart_Beta";

export interface BarChartProps {
  inputData: ChartData;
  chartPtn?: number;
  storageKeyGraph: string;
  fileName?: string;
  demographicDisplayPeriod: number;
  setDemographicDisplayPeriod: any;
  statementFlag?:boolean;
  setPoints: Option[],
  referenceDate: string,
}

export const BarChartStorageKey = {
  MsAdGroupListGraph: "MsAdGroupList_BarChart_Graph",
  IndividualSummaryGraph: "IndividualSummary_BarChart_Graph",
}

export const BarChart: React.FC<BarChartProps> = (props) => {
  // useForm
  const { control, errors } = useForm({
    reValidateMode: "onBlur",
  });

  const [graphValue, setGraphValue] = React.useState(2)

  const storageKeyGraph = props.storageKeyGraph
  const tmpFileName = props.fileName ? props.fileName.replace("YYYYMMDD_YYYYMMDD", year_date_format(props.demographicDisplayPeriod)) : "";
  const mergedSetPoints = [...props.setPoints];
  const options_list = generate_setpoint_options_list(props.chartPtn === LintChartColumnsPtn.Ptn2 ? options_demographic_graph_adgroup : options_demographic_graph_campaign, SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS.length, mergedSetPoints);

  const graphData = {
    labels: [
      // 軸ラベル
      // 各ラベルを配列にすることで軸ラベルが改行されて表示される
      ["0-4歳"],
      ["5-9歳"],
      ["10-14歳"],
      ["15-19歳"],
      ["20-24歳"],
      ["25-29歳"],
      ["30-34歳"],
      ["35-39歳"],
      ["40-44歳"],
      ["45-49歳"],
      ["50-54歳"],
      ["55-59歳"],
      ["60-64歳"],
      ["65-69歳"],
      ["70-74歳"],
      ["75-79歳"],
      ["80歳-"],
    ],
    datasets: [
      // 表示するデータセット
      {
        data: generate_datasets(props.inputData, GENDER_KIND.MALE, graphValue),
        backgroundColor: 'rgba(30, 144, 255, 1)',
        label: '男性',
      },
      {
        data: generate_datasets(props.inputData, GENDER_KIND.FEMALE, graphValue),
        backgroundColor: 'rgba(255, 30, 30, 1)',
        label: '女性',
      },
    ],
  };

  /** グラフオプション */
  const graphOption = {
    type: 'bar',
    scales: {
      xAxes: [
      // x軸オプション
        {
          scaleLabel: {
            // x軸ラベルオプション
            display: true,
            labelString: props.inputData[0][graphValue],
          },
          ticks: {
            callback: (value: number) => {
              if (value < 0) {
                  value = -value;
              }
              return generate_label_options_format(value, String(props.inputData[0][graphValue]));
            },
          },
        },
      ],
      yAxes: [
        // y軸オプション
        {
          scaleLabel: {
            // y軸ラベルオプション
            display: false,
            labelString: '',
          },
          categoryPercentage: 1,
          barPercentage: 1,
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem:any, data:any) {
          var label = 0;
          if (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] < 0) {
              label = -data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          } else {
              label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          }
          return tooltip_options_format(data.datasets[tooltipItem.datasetIndex].label, String(props.inputData[0][graphValue]), label);
        }
      }
    },
    legend: {
      display: true,
      position: 'right',
      labels: {
      },
    },
  };

  React.useEffect(() => {
    if (localStorage.getItem(storageKeyGraph) && props.inputData[0][Number(localStorage.getItem(storageKeyGraph))] !== undefined) {
      setGraphValue(Number(localStorage.getItem(storageKeyGraph)));
    }
  }, []);

  const handleChangeGraph = (event: React.ChangeEvent<{ value: unknown }>) => {
    setGraphValue(Number(event.target.value));
    localStorage.setItem(storageKeyGraph, String(event.target.value));
  };

  function generate_datasets(graphData: ChartData, genderIndex: number, valueIndex: number): number[] {
    const ret: number[] = new Array(DEMOGRAPHIC_COLUMNS.AGE_RANGE.length).fill(0);
    const index:number = DEMOGRAPHIC_COLUMNS.AGE_RANGE.length * (genderIndex - 1) + 1;

    for (let i = 0; i < ret.length; i++) {
      const value = graphData[i+index];
      if (genderIndex === GENDER_KIND.MALE) {
        ret[i] = -Number(value[valueIndex]);
      } else {
        ret[i] = Number(value[valueIndex]);
      }
    }

    return ret;
  }

  function year_date_format(periodKind: number): string {
    let ret = '';
    if (periodKind === DEMOGRAPHIC_DISPLAY_PERIOD.LAST_MONTH) {
      ret = `${moment(props.referenceDate).add(-30, 'day').format("YYYYMMDD")}_${moment(props.referenceDate).format("YYYYMMDD")}`;
    } else {
      ret = `${moment(props.referenceDate).add(-6, 'day').format("YYYYMMDD")}_${moment(props.referenceDate).format("YYYYMMDD")}`;
    }
    return ret;
  }

  function year_date_options_format(periodKind: number): string {
    const date = new Date(props.referenceDate);
    const endYear = date.getFullYear();
    const endMonth = date.getMonth() + 1;
    const endDay = date.getDate();
    let ret = '';

    if (periodKind === DEMOGRAPHIC_DISPLAY_PERIOD.LAST_MONTH) {
      date.setDate(date.getDate() - 30);
      const startYear = date.getFullYear();
      const startMonth = date.getMonth() + 1;
      const startDay = date.getDate();
      ret = `${startYear}/${startMonth}/${startDay}~${endYear}/${endMonth}/${endDay}`;
    } else {
      date.setDate(date.getDate() - 6);
      const startYear = date.getFullYear();
      const startMonth = date.getMonth() + 1;
      const startDay = date.getDate();
      ret = `${startYear}/${startMonth}/${startDay}~${endYear}/${endMonth}/${endDay}`;
    }
    return ret;
  }

  const handleDownload = () => {
    const fileName = tmpFileName !== "" ? tmpFileName : "histogram.csv";
    const csvData = formatChartCsvData(props.inputData, props.chartPtn === LintChartColumnsPtn.Ptn2 ? DemographicChartColumns2 : DemographicChartColumns1, SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS, mergedSetPoints);
    const data = csvData.map(e => e.join(",")).join("\n");
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, data], {type: 'text/csv'});

    const link = document.createElement("a");
    link.setAttribute("href", window.URL.createObjectURL(blob));
    link.setAttribute("download", fileName);
    document.body.appendChild(link);

    link.click();
  }

  const handleDownloadImage = (value: number) => {
    const fileFormat = valueToLabel(value, options_download_kind);
    const fileName = tmpFileName !== "" ? tmpFileName.replace(valueToLabel(DOWNLOAD_KIND.CSV, options_download_kind), fileFormat) : `histogram.${fileFormat}`;
    const chartNode = document.getElementById("histogram-container");

    if (chartNode !== null) {
      html2canvas(chartNode, { scale: 2 }).then((canvas) => {
        const link = document.createElement("a");
        link.setAttribute("href", canvas.toDataURL(`image/${fileFormat}`));
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      });
    }
  }

  return (
    <React.Fragment>
      <Grid container spacing={1} direction="row" justify="flex-end" alignItems="center">
        <Grid item xs={4}>
          <Select
            native
            value={graphValue}
            onChange={handleChangeGraph}
          >
            {options_list}
          </Select>
        </Grid>

        <Grid item xs={6}>
          <ApolloBasicRadio
            id="demographicDisplayPeriod"
            label=""
            options={options_demographic_display_period_kind}
            value={props.demographicDisplayPeriod}
            control={control}
            errors={errors}
            setState={(e: any) => props.setDemographicDisplayPeriod(Number(e))}
          />
        </Grid>

        <Grid item xs={2}>
          <ApolloIconButtonDownloadImage handleDownload={handleDownload} handleDownloadImage={handleDownloadImage} title={"ダウンロード"}/>
        </Grid>
      </Grid>

      <Grid container spacing={1} justify="center">
        <Grid item xs={12} lg={12}>
          <div id="histogram-container">
            <p style={{ textAlign: "center" }}>
              表示期間：{year_date_options_format(props.demographicDisplayPeriod)}
            </p>
            <HorizontalBar height={200} data={graphData} options={graphOption} />
          </div>
          {props.statementFlag &&
            <p style={{ textAlign: "center" }}>
              ※パフォーマンス広告はグラフ表示対象外
            </p>
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function generate_label_options_format(value: number, columnName: string): string {
  var ret = '';

  var labels = columnName.split("(");
  if (options_setpoint_columns.some((item) => item.label === labels[0])) {
    for (let column of options_setpoint_columns) {
      if (labels[0] === column.label){
        switch (column.label) {
          case 'ラストクリックCV':
          case 'アシストクリックCV':
            ret = `${value}`;
            break;
          case 'ラストクリックCVR':
            ret = (value * 100).toFixed(0) + '%';
            break;
          case 'ラストクリックCPA':
            ret = value.toLocaleString("ja-JP", {
              style: "currency",
              currency: "JPY",
            });
            break;
          default:
            break;
        }
      }
    }
  } else {
    switch (columnName) {
      case 'cost':
      case '平均CPC':
      case 'CPM':
      case 'CPA(合計)':
      case 'アシストクリックCPA(合計)':
      case '最適化ポイントCPA':
        ret = value.toLocaleString("ja-JP", {
          style: "currency",
          currency: "JPY",
        });
        break;
      case 'CTR':
      case 'vCTR':
      case 'CVR(合計)':
      case 'アシストクリックCVR(合計)':
      case '最適化ポイントCVR':
        ret = (value * 100).toFixed(0) + '%';
        break;
      default:
        ret = `${value}`;
        break;
    }
  }

  return ret;
}